import { ForwardedRef, forwardRef } from 'react';
import Card from '../Card';
import { colors } from '../../../../colors';

interface Props {
  isActive: boolean;
  handleFinish: () => void;
  handleBackPress: () => void;
}

const Redirect = forwardRef(
  (
    { isActive, handleFinish, handleBackPress }: Props,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <Card
        index={5}
        title="Onboarding Completed!"
        isActive={isActive}
        isFinished
        ref={ref}
        handleBackPress={handleBackPress}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            flex: 1,
          }}
        >
          <p
            style={{
              margin: 0,
              color: colors.mossGreen,
              fontSize: 16,
              fontWeight: 'bold',
              marginBottom: 16,
            }}
          >
            That marks the end of the onboarding process!
          </p>

          <p
            style={{
              margin: 0,
              color: colors.white,
              fontSize: 16,
              fontWeight: 'bold',
            }}
          >
            You are now ready to subscribe to your first bot! Enjoy the gains
            and welcome aboard!
          </p>

          <p
            style={{
              margin: 0,
              color: colors.white,
              fontSize: 16,
              fontWeight: 'bold',
              flex: 1,
            }}
          >
            Remember, you&apos;re still putting real money in risky investments,
            proceed with caution.
          </p>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'end',
              flex: '0 0 auto',
            }}
          >
            <button
              onClick={handleFinish}
              style={{
                backgroundColor: colors.green,
                border: `1px solid ${colors.green}`,
                borderRadius: 4,
                cursor: 'pointer',
                padding: 6,
                paddingLeft: 12,
                paddingRight: 12,
                color: colors.white,
                fontWeight: 'bold',
                textWrap: 'nowrap',
                fontSize: 16,
              }}
            >
              Enter the app!
            </button>
          </div>
        </div>
      </Card>
    );
  },
);

Redirect.displayName = 'Redirect';

export default Redirect;

/** Ask if the user wants to receive emails
 * Give quick info about credits system, pausing subscriptions, available pages
 */
